<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Employee Form
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>ID Karyawan</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewnik" placeholder="ID Number" :state="!$v.model.crewnik.$error"></b-form-input>
                        <b-input-group-prepend><span class="ml-3 pt-2">Status</span></b-input-group-prepend>
                      <b-form-radio-group class="ml-2 pt-2" v-model="model.terminate" name="radioTerminate" style="background-color: whitesmoke;">
                        <b-form-radio value="0">Active</b-form-radio>
                        <b-form-radio value="1">Terminate/Resign</b-form-radio>
                      </b-form-radio-group>
                    </b-input-group>
                    <b-input-group v-if="model.terminate==1">
                        <b-input-group-prepend><label>Date Inactive</label></b-input-group-prepend>
                        <b-form-select v-model="model.terminateType" :options="terminateTypeOpt">
                        </b-form-select>
                        <b-form-input v-model="model.terminateDate" type="date"  class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-input-group v-if="model.terminate==1">
                      <b-input-group-prepend><label>Reason </label></b-input-group-prepend>
                        <b-form-textarea id="terminateReason" v-model="model.terminateReason"
                          placeholder="Reason" rows="2" max-rows="6"></b-form-textarea>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Nama Lengkap</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewname" placeholder="Name" :state="!$v.model.crewname.$error"></b-form-input>
                      <b-form-radio-group class="ml-2 mt-2" v-model="model.crewmale" name="radioMale">
                        <b-form-radio value="1">Male</b-form-radio>
                        <b-form-radio value="0">Female</b-form-radio>
                      </b-form-radio-group>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Tempat, Tgl Lahir</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewpob" placeholder="Place Of Birth"></b-form-input>
                      <b-form-input v-model="model.crewdob" type="date"  class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Alamat Tinggal</label></b-input-group-prepend>
                        <b-form-textarea id="crewaddr" v-model="model.crewaddr"
                          placeholder="Home Address..." rows="2" max-rows="6"></b-form-textarea>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Phone & Email</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewhp" :state="!$v.model.crewhp.$error" placeholder="phone#1, phone#2, ..." ></b-form-input>
                      <b-form-input v-model="model.crewmail" type="email" :state="!$v.model.crewmail.$error" placeholder="email#1, email#2, ..." class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>KTP/KITAS</label></b-input-group-prepend>
                      <b-form-input v-model="model.ktp" placeholder="KTP/KITAS"></b-form-input>
                      <b-form-radio-group class="ml-2 mt-2" v-model="model.wni" name="radioWni">
                          <b-form-radio value="1">Indonesian</b-form-radio>
                          <b-form-radio value="0">Expatriate</b-form-radio>
                      </b-form-radio-group>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Alamat KTP</label></b-input-group-prepend>
                        <b-form-textarea id="alamatwp" v-model="model.alamatwp"
                          placeholder="Alamat KTP" rows="2" max-rows="6"></b-form-textarea>
                    </b-input-group>
                    <!-- <b-input-group >
                      <b-input-group-prepend><label>Marital Status</label></b-input-group-prepend>
                        <b-form-select v-model="model.kawin" :plain="true" :options="maritalStatus"></b-form-select>
                        <b-input-group-prepend><span class="ml-2 pt-2">&nbsp; Dependent (Children+Wife)&nbsp; </span></b-input-group-prepend>    
                        <b-form-input v-model="model.tanggungan" type="number"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">person(s)</span></b-input-group-prepend>    
                    </b-input-group> -->
                    <b-input-group >
                      <b-input-group-prepend><label>NPWP</label></b-input-group-prepend>
                      <b-form-input v-model="model.npwp" placeholder="NPWP" style="width:30% !important;"></b-form-input>
                        <b-input-group-prepend><span class="p-2">Kawin</span></b-input-group-prepend>    
                        <b-form-select v-model="model.kawin" :plain="true" :options="maritalStatus" style="width:15% !important;"></b-form-select>
                        <!-- <b-input-group-prepend><span class="p-2">Tanggungan</span></b-input-group-prepend>     -->
                        <b-form-input v-model="model.tanggungan" type="number" v-b-tooltip.hover :title="`Tanggungan ${model.tanggungan}`" class="ml-1"></b-form-input>
                        <!-- <b-input-group-prepend><span class="input-group-text">person(s)</span></b-input-group-prepend>     -->
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Pendidikan Formal</label></b-input-group-prepend>
                        <b-form-input v-model="model.pendidikan1" placeholder="Jenjang"></b-form-input>
                        <b-form-input v-model="model.pendidikan2" placeholder="Kampus" class="ml-1"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Agama</label></b-input-group-prepend>
                        <b-form-input v-model="model.religion" placeholder="Agama"></b-form-input>
                        <b-input-group-prepend><span class="p-2">ID Mesin Absensi</span></b-input-group-prepend>
                        <b-form-input v-model="model.noabsensi" placeholder="ID Mesin Absensi"></b-form-input>
                    </b-input-group>
                    <h5 >Emergency Contact</h5>
                    <b-input-group >
                      <b-input-group-prepend><label>Contact #1</label></b-input-group-prepend>
                        <b-form-input v-model="model.keluarga1" placeholder="Name"></b-form-input>
                        <b-form-input v-model="model.keluarga2" placeholder="Relationship" class="ml-1"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Telp.</span></b-input-group-prepend>
                        <b-form-input v-model="model.keluargatlp" ></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Contact #2</label></b-input-group-prepend>
                        <b-form-input v-model="model.keluargaAlt1" placeholder="Name"></b-form-input>
                        <b-form-input v-model="model.keluargaAlt2" placeholder="Relationship" class="ml-1"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Telp.</span></b-input-group-prepend>
                        <b-form-input v-model="model.keluargaAlt1Tlp" ></b-form-input>
                    </b-input-group>
                   
                </b-col>
                <b-col lg="6">
                    <b-row> 
                      <b-col cols="9">
                        <b-input-group>
                            <b-input-group-prepend><label>Company</label></b-input-group-prepend>
                            <b-form-select
                                v-model="model.compcode"
                                :options="companiesOpt"
                                :state="!$v.model.compcode.$error"
                                ></b-form-select>
                          </b-input-group>
                          <b-input-group >
                                <!-- <b-input-group-prepend class="d-md-none d-lg-inline"><label>&nbsp;</label></b-input-group-prepend> -->
                            <b-input-group-prepend><label>Employment Type</label></b-input-group-prepend>
                                <b-form-radio-group class="mt-2" v-model="model.staffTetap" name="radioTetap">
                                  <b-form-radio :value="0">Certain Time Contract (PKWT)</b-form-radio>
                                  <b-form-radio :value="1">Permanent Employee (PKWTT)</b-form-radio>
                                </b-form-radio-group>         
                          </b-input-group>
                          <b-input-group>
                            <b-input-group-prepend><label>Agreement/Contract</label></b-input-group-prepend>
                            <b-form-input v-model="model.contractNo"></b-form-input>
                            <b-form-input v-model="model.contractDate" type="date" class="ml-1"></b-form-input>
                          </b-input-group>
                          <b-input-group>
                            <b-input-group-prepend><label>Start/Join Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.joinDate" type="date" class="mr-1"></b-form-input>
                            <b-form-input :disabled="(model.staffTetap==1)" v-model="model.expiredDate" type="date"></b-form-input>
                          </b-input-group>
                          <b-input-group v-if="(model.staffTetap==1)">
                            <b-input-group-prepend><label>Start Permanent</label></b-input-group-prepend>
                            <b-form-input v-model="model.awaltetap" type="date"></b-form-input>
                            <b-input-group-prepend><span class="input-group-text">after probation</span></b-input-group-prepend>                            
                          </b-input-group>
                          <!-- <b-input-group>
                              <b-input-group-prepend><label>Pajak Penghasilan</label></b-input-group-prepend>  
                              <b-form-checkbox class="pt-1"  v-model="model.gajiNet" value=1 unchecked-value=0><b>Nett/Gross Up</b></b-form-checkbox>
                          </b-input-group> -->
                        <b-input-group>
                          <b-input-group-prepend><label>Working Time </label></b-input-group-prepend>
                          <b-form-input v-model="model.workinghour" type="number" :state="!$v.model.workingtime.$error"></b-form-input>
                          <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Excl.Rest</span></b-input-group-prepend>  
                          <b-form-input v-model="model.workingtime" type="number" :state="!$v.model.workingtime.$error"></b-form-input>
                          <b-form-checkbox class="ml-3 mt-2 mr-2" v-model="model.overtimeable" value=1 unchecked-value=0><b>Eligible OverTime</b></b-form-checkbox>
                        </b-input-group>
                        <b-input-group>
                          <b-input-group-prepend><label>Working Time </label></b-input-group-prepend>
                            <b-form-radio-group class="ml-1 mt-2" v-model="model.officer" name="radioOfficer">
                              <b-form-radio value="0">SHIFT/Scheduled </b-form-radio>
                              <b-form-radio value="1">Office/Daily Worker</b-form-radio>
                            </b-form-radio-group>
                        </b-input-group>
                      </b-col>
                      <b-col cols="3">
                          <div style="float-right;" class="text-right">
                                <my-upload field="gambar" 
                                    @crop-success="cropSuccess"
                                    @crop-upload-success="cropUploadSuccess"
                                    @crop-upload-fail="cropUploadFail"
                                    v-model="showImgTool"
                                    :width="100"
                                    :height="100"
                                    :url="imgUploadUrl"
                                    langType="en"
                                    :params="imgParams"
                                    :headers="imgHeaders"
                                    img-format="png"></my-upload>
                                <img :src="imgDataUrl" class="border border-primary" width="180" height="180">
                              <div style="display:block;">
                                <b-button variant="btn btn-primary" @click="toggleShowImg()" style="width:180px;"> 
                                  <i class="fa fa-file-image-o"></i> Upload Photo</b-button>
                              </div>
                          </div>
                      </b-col>
                    </b-row>

                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" :state="!$v.model.jabatan.$error"></b-form-input>
                    </b-input-group>
                    <b-row no-gutters>
                       <b-col md="6">
                          <b-input-group >
                            <b-input-group-prepend><label>Position</label></b-input-group-prepend>
                              <!-- <b-form-select v-model="model.pangkatid" :plain="true" :options="jobPositions" :state="!$v.model.pangkatid.$error"></b-form-select> -->
                              <b-form-input readonly v-model="model.pangkat" :state="!$v.model.pangkatid.$error"></b-form-input>
                              <b-input-group-append>
                                  <b-btn text="Button" @click="lkuPangkatShow=true" ><i class="fa fa-search"></i></b-btn>
                              </b-input-group-append>
                          </b-input-group>
                       </b-col>
                       <b-col md="6">
                        <b-input-group >
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Grade/Golongan</span></b-input-group-prepend>
                            <!-- <b-form-select v-model="model.golonganid" :plain="true" :options="jobGroups" :state="!$v.model.golonganid.$error"></b-form-select> -->
                            <b-form-input readonly v-model="model.golongan" :state="!$v.model.golonganid.$error"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="lkuGolonganShow=true" ><i class="fa fa-search"></i></b-btn>
                            </b-input-group-append>
                        </b-input-group>       
                       </b-col>
                    </b-row>
                    <b-row no-gutters>
                       <b-col md="6">
                          <b-input-group >
                            <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                              <!-- <b-form-select v-model="model.departid" :plain="true" :options="departments" :state="!$v.model.departid.$error"></b-form-select> -->
                              <b-form-input readonly v-model="model.departemen" :state="!$v.model.departid.$error"></b-form-input>
                              <b-input-group-append>
                                  <b-btn text="Button" @click="lkuDepartmentShow=true" ><i class="fa fa-search"></i></b-btn>
                              </b-input-group-append>
                          </b-input-group>
                       </b-col>
                       <b-col md="6">
                          <b-input-group >
                              <b-input-group-prepend><span class="ml-2 pt-2 mr-1">UpLine/Manager</span></b-input-group-prepend>
                              <b-form-input readonly v-model="model.managerinfo" ></b-form-input>
                              <b-input-group-append>
                                  <b-btn text="Button" @click="lkuCrewShow=true" ><i class="fa fa-search"></i></b-btn>
                              </b-input-group-append>
                          </b-input-group>
                       </b-col>
                    </b-row>
                    <b-input-group >
                        <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.locationname" :state="!$v.model.locationname.$error"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" :state="!$v.model.projectid.$error"></b-form-input>
                        <b-input-group-append>
                            <b-btn text="Button" @click="lkuCustomerShow=true" ><i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <br>
                    <b-input-group >
                        <b-input-group-prepend><label>BPJS Kesehatan</label></b-input-group-prepend>
                        <b-form-input v-model="model.bpjsks"  placeholder="Kesehatan" class="ml-1"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">BPJS TK</span></b-input-group-prepend>
                        <b-form-input v-model="model.noastek"  placeholder="Ketenagakerjaan"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Asuransi</label></b-input-group-prepend>
                        <b-form-input v-model="model.asuransi"  placeholder="Asuransi" class="ml-1"></b-form-input>
                    </b-input-group>
                    
                </b-col>
            </b-row>
            <b-row> 
                <b-col lg="6">
                    <b-card >
                        <h5 >Certificates/License (Education/Training)</h5>
                        <b-table
                            class="mb-0"
                            ref="tblTraining"
                            outlined striped hover small
                            style="font-size:smaller;" 
                            :items="trainings.items"
                            :fields="trainings.fields"
                            :current-page="trainings.page"
                            :per-page="trainings.limit"
                                show-empty
                            >
                                <template v-slot:cell(index)="data">
                                    {{data.index + 1}}
                                </template>
                                <template v-slot:cell(issuedDate)="data">
                                <span v-if="(data.item.issuedDate)">{{ data.item.issuedDate | moment("DD-MMM-YYYY") }}</span>
                                </template>
                                <template v-slot:cell(expiredDate)="data">
                                    <span v-if="(data.item.recurrent==1)">{{ data.item.expiredDate | moment("DD-MMM-YYYY") }}</span>
                                </template>
                                <template v-slot:cell(empty)="scope">
                                    <h4>{{ scope.emptyText }}</h4>
                                </template>
                                <template v-slot:cell(emptyfiltered)="scope">
                                    <h4>{{ scope.emptyFilteredText }}</h4>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <div class="text-center">
                                    <a href="javascript:void(0)" @click="editTraining(data.item,data.toggleDetails)">
                                        <i class="fa fa-pencil"></i>
                                    </a>
                                    |
                                    <a href="javascript:void(0)" class="text-danger" @click="delTraining(data.index)">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    </div>
                                </template>
                            <template v-slot:row-details="row">
                            <b-card class="row-details-form">
                                <b-input-group>
                                    <b-input-group-prepend><label>Certificate Name</label></b-input-group-prepend>
                                    <b-form-input v-model="trainingsObj.title" :state="!$v.trainingsObj.title.$error" ></b-form-input>
                                </b-input-group>
                                <b-input-group>
                                    <b-input-group-prepend><label>Skill</label></b-input-group-prepend>
                                    <b-form-input v-model="trainingsObj.skill" :state="!$v.trainingsObj.skill.$error" ></b-form-input>
                                </b-input-group>
                                <b-row>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Issued Date</label></b-input-group-prepend>
                                            <b-form-input v-model="trainingsObj.issuedDate" :state="!$v.trainingsObj.issuedDate.$error" type="date"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Recurrent</label></b-input-group-prepend>
                                            <b-form-radio-group  v-model="trainingsObj.recurrent" name="radioRecurrent" class="ml-1 mt-1" >
                                                <b-form-radio :value="1">YES</b-form-radio>
                                                <b-form-radio :value="0">NO</b-form-radio>
                                            </b-form-radio-group>
                                        </b-input-group>
                                    <div v-if="($v.trainingsObj.recurrent.$dirty && !$v.trainingsObj.recurrent.$anyError)" style="text-align:right; color:red;">Please select YES or NO !</div>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(trainingsObj.recurrent == 1)">
                                    <b-col lg="6">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Expired Date</label></b-input-group-prepend>
                                            <b-form-input v-model="trainingsObj.expiredDate" :state="!$v.trainingsObj.expiredDate.$error" type="date"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Recurrent Plan</label></b-input-group-prepend>
                                            <b-form-input v-model="trainingsObj.recurrentPlan" type="date"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-input-group>
                                    <b-input-group-prepend><label>Remark</label></b-input-group-prepend>
                                    <b-form-input v-model="trainingsObj.remark" ></b-form-input>
                                </b-input-group>
                                    <b-row class="justify-content-center">
                                        <b-button class="btn btn-info mr-1" @click="saveTraining()">Update</b-button>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-row>

                            </b-card>
                            </template>                        
                        </b-table>
                        <b-row class="mt-2">
                            <b-col cols="7">
                                <b-row>
                                    <b-button size="sm" class="ml-3" @click="addTraining" >Add Certificate</b-button>  
                                    <div>
                                        <span class="ml-2 mr-1">Per page:</span> 
                                    <select  v-model="trainings.limit"  style="width:60px;">
                                        <option>10</option>
                                        <option>15</option>
                                        <option>20</option>
                                        <option>55</option>
                                    </select>  &nbsp;                                      
                                    Showing {{(trainings.page - 1) * trainings.limit + 1}}
                                    to <span v-if="((trainings.page * trainings.limit)>trainings.total)">{{trainings.total}}</span> <span v-else>{{trainings.page * trainings.limit}}</span>
                                    of {{trainings.total}} 
                                    </div>
                                </b-row>
                            </b-col>
                            <b-col cols="5">
                                    <b-pagination 
                                    align="right"
                                    :total-rows="trainings.total"
                                    :per-page="trainings.limit"
                                    v-model="trainings.page"
                                    ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col lg="6">
                    <b-card>
                        <h5>Working Experience</h5>
                        <b-table
                            class="mb-0"
                            ref="tblWorking"
                            outlined striped hover small
                            style="font-size:smaller;" 
                            :items="workings.items"
                            :fields="workings.fields"
                            :current-page="workings.page"
                            :per-page="workings.limit"
                                show-empty
                            >
                                <template v-slot:cell(index)="data">
                                    {{data.index + 1}}
                                </template>
                                <template v-slot:cell(startDate)="data">
                                <span v-if="(data.item.startDate)">{{ data.item.startDate | moment("DD-MMM-YYYY") }}</span>
                                </template>
                                <template v-slot:cell(endDate)="data">
                                    <span v-if="(data.item.endDate)">{{ data.item.endDate | moment("DD-MMM-YYYY") }}</span>
                                </template>
                                <template v-slot:cell(empty)="scope">
                                    <h4>{{ scope.emptyText }}</h4>
                                </template>
                                <template v-slot:cell(emptyfiltered)="scope">
                                    <h4>{{ scope.emptyFilteredText }}</h4>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <div class="text-center">
                                    <a href="javascript:void(0)" @click="editWorking(data.item,data.toggleDetails)">
                                        <i class="fa fa-pencil"></i>
                                    </a>
                                    |
                                    <a href="javascript:void(0)" class="text-danger" @click="delWorking(data.index)">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    </div>
                                </template>
                            <template v-slot:row-details="row">
                            <b-card class="row-details-form">
                                <b-input-group>
                                    <b-input-group-prepend><label>Employer Name</label></b-input-group-prepend>
                                    <b-form-input v-model="workingsObj.employer" :state="!$v.workingsObj.employer.$error" ></b-form-input>
                                </b-input-group>
                                <b-input-group>
                                    <b-input-group-prepend><label>Industry</label></b-input-group-prepend>
                                    <b-form-input v-model="workingsObj.industry" :state="!$v.workingsObj.industry.$error" ></b-form-input>
                                </b-input-group>
                                <b-input-group>
                                    <b-input-group-prepend><label>Job Position</label></b-input-group-prepend>
                                    <b-form-input v-model="workingsObj.title" :state="!$v.workingsObj.title.$error" ></b-form-input>
                                </b-input-group>
                                <b-row>
                                    <b-col lg="12">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Working Periode</label></b-input-group-prepend>
                                            <b-form-input v-model="workingsObj.startDate" :state="!$v.workingsObj.startDate.$error" type="date"></b-form-input>
                                            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                            <b-form-input v-model="workingsObj.endDate"  type="date"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                    <b-row class="justify-content-center">
                                        <b-button class="btn btn-info mr-1" @click="saveWorking()">Update</b-button>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-row>

                            </b-card>
                            </template>                        
                        </b-table>
                        <b-row class="mt-2">
                            <b-col cols="7">
                                <b-row >
                                    <b-button size="sm" class="ml-3" @click="addWorking" >Add Work Experience</b-button>  
                                    <div>
                                        <span class="ml-2">Per page:</span> 
                                    <select  v-model="workings.limit"  style="width:60px;">
                                        <option>10</option>
                                        <option>15</option>
                                        <option>20</option>
                                        <option>55</option>
                                    </select> &nbsp;&nbsp;
                                    Showing {{(workings.page - 1) * workings.limit + 1}}
                                    to <span v-if="((workings.page * workings.limit)>workings.total)">{{workings.total}}</span> <span v-else>{{workings.page * workings.limit}}</span>
                                    of {{workings.total}}  
                                    </div>
                                </b-row>    
                            </b-col>
                            <b-col cols="5">
                                    <b-pagination 
                                    align="right"
                                    :total-rows="workings.total"
                                    :per-page="workings.limit"
                                    v-model="workings.page"
                                    ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col lg="6">
                    <b-card >
                        <h5 >Family Members</h5>
                        <b-table
                            class="mb-0"
                            ref="tblTraining"
                            outlined striped hover small
                            style="font-size:smaller;" 
                            :items="familyMembers.items"
                            :fields="familyMembers.fields"
                            :current-page="familyMembers.page"
                            :per-page="familyMembers.limit"
                                show-empty
                            >
                                <template v-slot:cell(index)="data">
                                    {{data.index + 1}}
                                </template>
                                <template v-slot:cell(empty)="scope">
                                    <h4>{{ scope.emptyText }}</h4>
                                </template>
                                <template v-slot:cell(emptyfiltered)="scope">
                                    <h4>{{ scope.emptyFilteredText }}</h4>
                                </template>

                                <template v-slot:cell(DOB)="data">
                                    <span v-if="(data.item.DOB)">{{ data.item.DOB | moment("DD-MMM-YYYY") }}</span>
                                </template>
                                <template v-slot:cell(male)="data">
                                    <span v-if="(data.item.male==1)">Male</span>
                                    <span v-else>Female</span>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <div class="text-center">
                                    <a href="javascript:void(0)" @click="editFamilyMember(data.item,data.toggleDetails)">
                                        <i class="fa fa-pencil"></i>
                                    </a>
                                    |
                                    <a href="javascript:void(0)" class="text-danger" @click="delFamilyMember(data.index)">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    </div>
                                </template>
                            <template v-slot:row-details="row">
                            <b-card class="row-details-form">
                                <b-input-group>
                                    <b-input-group-prepend><label>Full Name</label></b-input-group-prepend>
                                    <b-form-input v-model="familyMemberObj.fullname" :state="!$v.familyMemberObj.fullname.$error" ></b-form-input>
                                </b-input-group>
                                <b-row>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Gender</label></b-input-group-prepend>
                                            <b-form-radio-group class="ml-2 mt-2" v-model="familyMemberObj.male" name="radioMale">
                                                <b-form-radio value="1">Male</b-form-radio>
                                                <b-form-radio value="0">Female</b-form-radio>
                                            </b-form-radio-group>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group>
                                    <b-input-group-prepend><label>NIK</label></b-input-group-prepend>
                                    <b-form-input v-model="familyMemberObj.NIK"></b-form-input>
                                </b-input-group>
                                    </b-col>
                                </b-row>
                                
                                <b-row>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Place Of Birth</label></b-input-group-prepend>
                                            <b-form-input v-model="familyMemberObj.POB" ></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Date Of Birth</label></b-input-group-prepend>
                                            <b-form-input v-model="familyMemberObj.DOB" :state="!$v.familyMemberObj.DOB.$error" type="date"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                
                                <b-input-group>
                                    <b-input-group-prepend><label>Relationship</label></b-input-group-prepend>
                                    <b-form-input v-model="familyMemberObj.relationship" ></b-form-input>
                                </b-input-group>
                                    <b-row class="justify-content-center">
                                        <b-button class="btn btn-info mr-1" @click="saveFamilyMember()">Update</b-button>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-row>

                            </b-card>
                            </template>                        
                        </b-table>
                        <b-row class="mt-2">
                            <b-col cols="7">
                                <b-row>
                                    <b-button size="sm" class="ml-3" @click="addFamilyMember" >Add Member</b-button>  
                                    <div>
                                        <span class="ml-2 mr-1">Per page:</span> 
                                    <select  v-model="familyMembers.limit"  style="width:60px;">
                                        <option>10</option>
                                        <option>15</option>
                                        <option>20</option>
                                        <option>55</option>
                                    </select>  &nbsp;                                      
                                    Showing {{(familyMembers.page - 1) * familyMembers.limit + 1}}
                                    to <span v-if="((familyMembers.page * familyMembers.limit)>familyMembers.total)">{{familyMembers.total}}</span> <span v-else>{{familyMembers.page * familyMembers.limit}}</span>
                                    of {{familyMembers.total}} 
                                    </div>
                                </b-row>
                            </b-col>
                            <b-col cols="5">
                                    <b-pagination 
                                    align="right"
                                    :total-rows="familyMembers.total"
                                    :per-page="familyMembers.limit"
                                    v-model="familyMembers.page"
                                    ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col lg="6">
                    <b-card >
                        <h5 >Documents</h5>
                        <b-table
                            class="mb-0"
                            ref="tblTraining"
                            outlined striped hover small
                            style="font-size:smaller;" 
                            :items="documentOfCrew.items"
                            :fields="documentOfCrew.fields"
                            :current-page="documentOfCrew.page"
                            :per-page="documentOfCrew.limit"
                                show-empty
                            >
                                
                                
                                <template v-slot:cell(empty)="scope">
                                    <h4>{{ scope.emptyText }}</h4>
                                </template>
                                <template v-slot:cell(emptyfiltered)="scope">
                                    <h4>{{ scope.emptyFilteredText }}</h4>
                                </template>
                                <template v-slot:cell(index)="data">
                                    {{data.index + 1}}
                                </template>
                                <template v-slot:cell(attchFileSize)="data">
                                    <!-- <span v-if="data.item.attchFileSize /1000000 > 0.1"> {{data.item.attchFileSize /1000000}} MB</span>
                                    <span v-if="data.item.attchFileSize /1000 > 0.1"> {{data.item.attchFileSize /1000}} KB</span>
                                    <span v-else>0</span> -->
                                   {{ data.item.attchFileSize | numFormat('0.00b') }}
                                </template>
                                <template v-slot:cell(action)="data">
                                    <div class="text-center">
                                    <a href="javascript:void(0)" @click="editDocument(data.item,data.toggleDetails)">
                                        <i class="fa fa-pencil"></i>
                                    </a>
                                    |
                                    <a href="javascript:void(0)" class="text-danger" @click="delDocument(data.index)">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    </div>
                                </template>
                            <template v-slot:row-details="row">
                            <b-card class="row-details-form">
                                <b-input-group>
                                    <b-input-group-prepend><label>File</label></b-input-group-prepend>
                                    <b-form-file
                                        v-model="documentOfCrewObj.attchFile"
                                        :state="!$v.documentOfCrewObj.attchFile.$error"
                                        placeholder="Choose a file or drop it here..."
                                        drop-placeholder="Drop file here..."
                                        ></b-form-file>                                
                                </b-input-group>
                                <b-input-group>
                                    <b-input-group-prepend><label>Remark</label></b-input-group-prepend>
                                    <b-form-input v-model="trainingsObj.remark" ></b-form-input>
                                </b-input-group>
                                    <b-row class="justify-content-center">
                                        <b-button class="btn btn-info mr-1" @click="saveDocument()">Update</b-button>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-row>

                            </b-card>
                            </template>                        
                        </b-table>
                        <b-row class="mt-2">
                            <b-col cols="7">
                                <b-row>
                                    <b-button size="sm" class="ml-3" @click="addDocument" >Add Documents</b-button>  
                                    <div>
                                        <span class="ml-2 mr-1">Per page:</span> 
                                    <select  v-model="documentOfCrew.limit"  style="width:60px;">
                                        <option>10</option>
                                        <option>15</option>
                                        <option>20</option>
                                        <option>55</option>
                                    </select>  &nbsp;                                      
                                    Showing {{(documentOfCrew.page - 1) * documentOfCrew.limit + 1}}
                                    to <span v-if="((documentOfCrew.page * documentOfCrew.limit)>documentOfCrew.total)">{{documentOfCrew.total}}</span> <span v-else>{{documentOfCrew.page * documentOfCrew.limit}}</span>
                                    of {{documentOfCrew.total}} 
                                    </div>
                                </b-row>
                            </b-col>
                            <b-col cols="5">
                                    <b-pagination 
                                    align="right"
                                    :total-rows="documentOfCrew.total"
                                    :per-page="documentOfCrew.limit"
                                    v-model="documentOfCrew.page"
                                    ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
                        
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-primary mr-1" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
    </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
            <lku-customer @click="onSelectLkuCustomer" isactive="1"></lku-customer>
        </b-modal>        
        <b-modal v-model="lkuDepartmentShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDepartment"></lku-department>
        </b-modal>        
        <b-modal v-model="lkuGolonganShow" size="lg" :hide-footer="true" title="List of Grade/Golongan" :centered="true">
            <lku-golongan @click="onSelectLkuGolongan"></lku-golongan>
        </b-modal>        
        <b-modal v-model="lkuPangkatShow" size="lg" :hide-footer="true" title="List of Position/Pangkat" :centered="true">
            <lku-pangkat @click="onSelectLkuPangkat"></lku-pangkat>
        </b-modal>        
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 90px;
                }
            }
        }

        legend {
        text-align: right !important;;
        }
    }
    .input-group > .custom-file:not(:first-child) .custom-file-label{
        text-align: left !important;
    }
</style>
<script>
import moment from 'moment';
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import crew from "../../apis/crewhr";
import crud from "../../apis/crud";
import lkuCrew from "../lookup/lkuCrew";
// import lkuCustomer from "../lookup/lkuCustomers";
import lkuCustomer from "../lookup/lkuProject";
import lkuDepartment from "../lookup/lkuDepartment";
import lkuGolongan from "../lookup/lkuGolongan";
import lkuPangkat from "../lookup/lkuPangkat";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components:{myUpload,lkuCustomer,lkuCrew,lkuDepartment,lkuGolongan,lkuPangkat},
  mixins: [validationMixin],
  validations: {
        model: {
            crewnik: { required },
            crewname: { required },
            jabatan: { required },
            departid: { required },
            golonganid: { required },
            pangkatid: { required },
            projectid: { required },
            locationname: { required },
            crewhp: { required },
            crewmail: { required },
            workingtime: { required },
            overtimeable: { required },
            officer: { required },
            staffTetap: { required },
            compcode:{required}
        },
        trainingsObj: {
            title: { required },
            skill: { required },
            issuedDate: { required },
            recurrent: { required },
            expiredDate : { required:(function() {
                if ((this.trainingsObj.recurrent || 0) == 0) {
                   this.trainingsObj.expiredDate='';
                    return true;
                } else if (!(this.trainingsObj.expiredDate)){
                    return false;
                } else return true;
            }) },
        },
        workingsObj: {
            employer: { required },
            title: { required },
            startDate: { required },
            industry: { required },
        },
        familyMemberObj: {
            fullname: { required },
            DOB:{ required },
        },
        documentOfCrewObj:{
            attchFile: { required },
        }
  }, 
  data () {
    return {
        horizontal:true,
        saveEnabled:true,
        model: {
            crewnik: '',
            crewname: '',
            bankaccno: '',
            bankname: '',
            beneficiary: '',
            jabatan: '',
            departid: '',
            golonganid: '',
            pangkatid: '',
            projectid:'0000', projectname:'NON PROJECT',
            locationname: '',
            crewhp: '',
            crewmail: '',
            workingtime: 8,
            overtimeable: 0,
            officer: 1,crewmale: 1,  managerkey: '', wni:1 , crewaddr:'', alamatwp:'',
            npwp:'', tanggungan:0, kawin:0,
            staffTetap: 0,compcode:'',
            terminate:0,
            terminateDate:'',
            terminateType:'',
            terminateReason:'',
            keluargaAlt1:'',keluargaAlt2:'',keluargaAlt1Tlp:'',
            asuransi:'',
        },
        terminateTypeOpt :[
                      { value: '', text: 'Please select an option' ,disabled: true},
        'Terminate','Resign'
        ],
        trainings: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "title",
                    label: "Certificate Name"
                },
                {
                    key: "skill",
                    label: "Skill/Kompetensi"
                },
                {
                    key: "issuedDate",
                    label: "Issued Date",
                    thStyle: "width:110px",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: true

                },
                {
                    key: "expiredDate",
                    label: "Expired Date",
                    thStyle: "width:110px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "remark",
                    label: "Remark"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        trainingsObj:{title:'',skill:'', issuedDate:'', recurrent:'0', expiredDate:''},
        workings: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "employer",
                    label: "Employer Name"
                },
                {
                    key: "industry",
                    label: "Industry"
                },
                {
                    key: "title",
                    label: "Job Position"
                },
                {
                    key: "startDate",
                    label: "Start Work ",
                    thStyle: "width:110px",
                    thClass: "text-center",
                    tdClass: "text-center",
                    sortable: true

                },
                {
                    key: "endDate",
                    label: "Finish Work",
                    thStyle: "width:110px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        workingsObj:{title:'', startDate:'', employer:'',industry:'', endDate:''},

        familyMembers: {
            items: [],
            selected:{},
            fields: [
                {key:'index', label: 'No.' ,thStyle: "width:40px"},
                {key:'fullname',label:'Full Name'},
                {key:'NIK',label:'NIK'},
                {key:'male',label:'Gender'},
                {key:'POB',label:'Place Of Birth'},
                {key:'DOB',label:'Date Of Birth'},
                // {key:'religion',label:'Religion'},
                // {key:'education',label:'Education'},
                // {key:'profession',label:'Profession'},
                // {key:'married',label:'Married'},
                {key:'relationship',label:'Relationship'},
                // {key:'wni',label:'WNI'},
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        familyMemberObj:{
            fullname:'',
            NIK:null,
            male:1,
            POB:'',
            DOB:'',
            religion:null,
            education:null,
            profession:null,
            married:0,
            relationship:null,
            wni:1,
        },
        documentOfCrew: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {key:'attchFileNm',label:'File Name'},
                // {key:'type',label:'Type'},
                {key:'attchFileSize',label:'Size'},
                {key:'remark',label:'Remark'},
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        documentOfCrewObj:{
            attchFile:null,
            attchFileNm:null,
            attchFileSize:0,
            remark:''
        },
        showImgTool:false,
        imgParams:{name:'gambar'},
        imgHeaders:{},
        imgDataUrl: '',
        imgUploadUrl: '',
        lkuCrewShow:false,
        lkuCustomerShow:false,
        lkuDepartmentShow:false,
        lkuGolonganShow:false,
        lkuPangkatShow:false,
        currency:[{value:'IDR',text:'IDR'}],
        maritalStatus: [{value:0,text:'TDK KAWIN'},{value:1,text:'KAWIN'},{value:2,text:'KAWIN BERPISAH'}],
        departments:[],
        jobPositions:[],
        jobGroups:[],
        tblDataCompany: {
            tablename: "company",
            page: 1,
            total: 0,
            limit: 1000,
            sortBy: "company",
            sortDesc: false,
        },
        companiesOpt: [],
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
      invalidTraining() {
        this.$v.trainingsObj.$touch();
        return this.$v.trainingsObj.$invalid;
      },
      invalidWorking() {
        this.$v.workingsObj.$touch();
        return this.$v.workingsObj.$invalid;
      },
      invalidFamilyMember() {
        this.$v.familyMemberObj.$touch();
        return this.$v.familyMemberObj.$invalid;
      },
      invalidDocumentCrew() {
        this.$v.documentOfCrewObj.$touch();
        return this.$v.documentOfCrewObj.$invalid;
      },
  },
  created: async function(){
        this.tblDataCompany.sortDir = this.tblDataCompany.sortDesc ? "desc" : "asc";
        const company = await crud.list(this.tblDataCompany);
        let companiesOpt = [{ value: "", text: "-- Select Company --" }];
        company.map((dt) => {
        companiesOpt.push({ value: dt.compcode, text: dt.company });
        });
        this.companiesOpt = companiesOpt;
      if (this.$route.params.crewkey)  {
          toastr.info('Loading Crew Detail, please wait')
          try {
            // const data = await crew.detail(this.$route.params);  
            const [a,b,c,data] = await Promise.all([crew.department(),crew.position(),crew.group(),crew.detail(this.$route.params)]) ;
            this.departments = a; 
            this.jobPositions = b; 
            this.jobGroups = c; 
            for (var key in data) {
               if ((key != 'trainings') && (key != 'workings')){
                  this.model[key] = data[key];
               }
            }
            const arrKlg=(this.model.keluarga || '').split('|');
            this.model.keluarga1 = arrKlg[0];
            if (arrKlg.length>1)  this.model.keluarga2 = arrKlg[1];

            const arrKlg2=(this.model.keluargaAlt1 || '').split('|');
            this.model.keluargaAlt1 = arrKlg2[0];
            if (arrKlg2.length>1)  this.model.keluargaAlt2 = arrKlg2[1];

            const arrPendik=(this.model.pendidikan || '').split('|');
            this.model.pendidikan1 = arrPendik[0];
            if (arrPendik.length>1)  this.model.pendidikan2 = arrPendik[1];

            this.model.crewdob = this.model.crewdob ? moment(this.model.crewdob).format('YYYY-MM-DD') : '';
            this.model.awaltetap = this.model.awaltetap ? moment(this.model.awaltetap).format('YYYY-MM-DD') : '';
            this.model.joinDate = this.model.joinDate ? moment(this.model.joinDate).format('YYYY-MM-DD') : '';
            this.model.contractDate = this.model.contractDate ? moment(this.model.contractDate).format('YYYY-MM-DD') : '';
            this.model.expiredDate = this.model.expiredDate ? moment(this.model.expiredDate).format('YYYY-MM-DD') : '';
            this.trainings.items= data.trainings;
            this.workings.items= data.workings;
            console.log('photo: ', this.model.photo);
            this.imgDataUrl=this.model.photo || '';
            this.$forceUpdate();
            toastr.clear;

          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
            const [a,b,c] = await Promise.all([crew.department(),crew.position(),crew.group()]) ;
            this.departments = a; 
            this.jobPositions = b; 
            this.jobGroups = c; 
      }

  },
  methods:{
    onSelectLkuCustomer: async function (_selected) {
        // this.model.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.model.projectname = _selected.projectname;
        this.model.projectcode = _selected.projectcode;
        this.model.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    onSelectLkuCrew: async function (_selected) {
        this.model.managerinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
        this.model.managerkey = _selected.crewkey;
        this.lkuCrewShow=false;
    },
    onSelectLkuDepartment: async function (_selected) {
        this.model.departemen = _selected.departemen.trim();
        this.model.departid = _selected.departid;
        this.model.departkd = _selected.departkd;
        this.lkuDepartmentShow=false;
    },
    onSelectLkuGolongan: async function (_selected) {
        this.model.golongan = _selected.golongan.trim();
        this.model.golonganid = _selected.golonganid;
        this.model.golongankd = _selected.golongankd;
        this.lkuGolonganShow=false;
    },
    onSelectLkuPangkat: async function (_selected) {
        this.model.pangkat = _selected.pangkat.trim();
        this.model.pangkatid = _selected.pangkatid;
        this.model.pangkatkd = _selected.pangkatkd;
        this.lkuPangkatShow=false;
    },
    closeTraining: function(){
        const opened= this.trainings.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addTraining : function () {
        this.closeTraining();
        const obj={_showDetails:true,title:'', issuedDate:'', recurrent:'0', expiredDate:''};
        this.trainings.selected = obj;
        this.trainingsObj.recurrent=1;
        this.trainingsObj.expiredDate = '';
        this.trainingsObj.issuedDate = '';
        this.trainingsObj.title = '';
        this.trainings.items.push(obj);
        this.trainings.total=this.trainings.items.length;
    },
    editTraining : function (obj,callback) {
        this.closeTraining();
        this.trainings.selected = obj;
        for (var key in this.trainingsObj) {
            this.trainingsObj[key] = '';
        }
        for (var key in obj) {
            this.trainingsObj[key] = obj[key];
        }
        this.trainingsObj.issuedDate = moment(obj.issuedDate).format('YYYY-MM-DD');
        this.trainingsObj.expiredDate = (obj.expiredDate) ? moment(obj.expiredDate).format('YYYY-MM-DD') :'';
        this.trainingsObj.recurrentPlan = (obj.recurrentPlan) ? moment(obj.recurrentPlan).format('YYYY-MM-DD') :'';
        callback();
    },
    delTraining: function (index) {
        if (index > -1) {
        this.trainings.items.splice(index, 1);
        }
        this.trainings.total=this.trainings.items.length;
    },
    saveTraining: async function (callback) {
        if (this.invalidTraining) {
            console.log('validation : ', this.$v.trainingsObj);
            console.log('model obj : ',this.trainingsObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    for (var key in this.trainingsObj) {
                        this.trainings.selected[key] = this.trainingsObj[key];
                    }
                    this.trainings.total=this.trainings.items.length;
                    this.trainings.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },
    closeWorking: function(){
        const opened= this.workings.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addWorking : function () {
        this.closeWorking();
        const obj={_showDetails:true,title:'', startDate:'', employer:'', endDate:''};
        this.workings.selected = obj;
        this.workingsObj.employer='';
        this.workingsObj.endDate = '';
        this.workingsObj.startDate = '';
        this.workingsObj.title = '';
        this.workings.items.push(obj);
        this.workings.total=this.workings.items.length;
    },
    editWorking : function (obj,callback) {
        this.closeWorking();
        this.workings.selected = obj;
        for (var key in this.workingsObj) {
            this.workingsObj[key] = '';
        }
        for (var key in obj) {
            this.workingsObj[key] = obj[key];
        }
        this.workingsObj.startDate = moment(obj.startDate).format('YYYY-MM-DD');
        this.workingsObj.endDate = (obj.endDate) ? moment(obj.endDate).format('YYYY-MM-DD') :'';
        callback();
    },
    delWorking: function (index) {
        if (index > -1) {
        this.workings.items.splice(index, 1);
        }
        this.workings.total=this.workings.items.length;
    },
    saveWorking: async function (callback) {
        if (this.invalidWorking) {
            console.log('validation : ', this.$v.workingsObj);
            console.log('model obj : ',this.workingsObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    for (var key in this.workingsObj) {
                        this.workings.selected[key] = this.workingsObj[key];
                    }
                    this.workings.total=this.workings.items.length;
                    this.workings.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },
    // START FAMILY MEMBERS
    closeFamilyMember: function(){
        const opened= this.familyMembers.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addFamilyMember : function () {
        this.closeFamilyMember();
        const obj={_showDetails:true,title:'', startDate:'', employer:'', endDate:''};
        this.familyMembers.selected = obj;
        this.familyMemberObj.male = 1;
        this.familyMembers.items.push(obj);
        this.familyMembers.total=this.familyMembers.items.length;
    },
    editFamilyMember : function (obj,callback) {
        this.closeFamilyMember();
        this.familyMembers.selected = obj;
        for (var key in this.familyMemberObj) {
            this.familyMemberObj[key] = '';
        }
        for (var key in obj) {
            this.familyMemberObj[key] = obj[key];
        }

        this.familyMemberObj.DOB = (obj.DOB||'')!=''?moment(obj.DOB).format('YYYY-MM-DD'):'';
        callback();
    },
    delFamilyMember: function (index) {
        if (index > -1) {
        this.familyMembers.items.splice(index, 1);
        }
        this.familyMembers.total=this.familyMembers.items.length;
    },
    saveFamilyMember: async function (callback) {
        if (this.invalidFamilyMember) {
            console.log('validation : ', this.$v.familyMemberObj);
            console.log('model obj : ',this.familyMemberObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    for (var key in this.familyMemberObj) {
                        this.familyMembers.selected[key] = this.familyMemberObj[key];
                    }
                    this.familyMembers.total=this.familyMembers.items.length;
                    this.familyMembers.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },

    // END

    // START DOCUMENTS
    closeDocument: function(){
        const opened= this.documentOfCrew.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addDocument : function () {
        this.closeDocument();
        const obj={_showDetails:true,title:'', startDate:'', employer:'', endDate:''};
        this.documentOfCrew.selected = obj;
        this.documentOfCrewObj.attchFile=null;
        this.documentOfCrewObj.attchFileNm = null;
        this.documentOfCrewObj.attchFileSize = 0;
        this.documentOfCrewObj.remark = '';
        this.documentOfCrew.items.push(obj);
        this.documentOfCrew.total=this.documentOfCrew.items.length;
    },
    editDocument : function (obj,callback) {
        this.closeDocument();
        this.documentOfCrew.selected = obj;
        for (var key in this.documentOfCrewObj) {
            this.documentOfCrewObj[key] = '';
        }
        for (var key in obj) {
            this.documentOfCrewObj[key] = obj[key];
        }
        this.documentOfCrewObj.startDate = moment(obj.startDate).format('YYYY-MM-DD');
        this.documentOfCrewObj.endDate = (obj.endDate) ? moment(obj.endDate).format('YYYY-MM-DD') :'';
        callback();
    },
    delDocument : function (index) {
        if (index > -1) {
        this.documentOfCrew.items.splice(index, 1);
        }
        this.documentOfCrew.total=this.documentOfCrew.items.length;
    },
    saveDocument : async function (callback) {
        if (this.invalidDocumentCrew) {
            console.log('validation : ', this.$v.documentOfCrewObj);
            console.log('model obj : ',this.documentOfCrewObj);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
                    console.log('this.documentOfCrewObj',this.documentOfCrewObj);
                    this.documentOfCrewObj.attchFileNm = this.documentOfCrewObj.attchFile.name;
                    this.documentOfCrewObj.attchFileSize=this.documentOfCrewObj.attchFile.size;
                    for (var key in this.documentOfCrewObj) {
                        this.documentOfCrew.selected[key] = this.documentOfCrewObj[key];
                    }
                    this.documentOfCrew.total=this.documentOfCrew.items.length;
                    this.documentOfCrew.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'Error Info',10000);
                } else {
                    toastr.error(JSON.stringify(error),'Error Info',10000);
                }
            }
        }
    },
    // END 
    save: async function(){
        // this.model.npwp_name = this.model.npwp_name || this.model.itemname;
        // this.model.npwp_address1 = this.model.npwp_address1 || this.model.item_address1 ;
        // this.model.npwp_address2 = this.model.npwp_address2 || this.model.item_address2;
        // this.model.npwp_city = this.model.npwp_city || this.model.item_city;
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.photo=this.imgDataUrl;
              data.crewdob = data.crewdob ? moment(data.crewdob).format('YYYY-MM-DD') : undefined;
              data.joinDate = data.joinDate ? moment(data.joinDate).format('YYYY-MM-DD') : undefined;
              data.awaltetap = data.awaltetap ? moment(data.awaltetap).format('YYYY-MM-DD') : undefined;
              data.terminateDate = data.terminateDate ? moment(data.terminateDate).format('YYYY-MM-DD') : undefined;
              data.keluarga = `${data.keluarga1} | ${data.keluarga2}`; 
              data.keluargaAlt1 = `${data.keluargaAlt1} | ${data.keluargaAlt2}`; 
              data.trainings = this.trainings.items.reduce((newArr, item) => {
                  if (((item.title || '') != '') && (item.issuedDate)) {
                      item.issuedDate = (item.issuedDate) ? moment(item.issuedDate).format('YYYY-MM-DD') :'';
                      item.expiredDate = (item.expiredDate) ? moment(item.expiredDate).format('YYYY-MM-DD') :'';
                      item.recurrentPlan = (item.recurrentPlan) ? moment(item.recurrentPlan).format('YYYY-MM-DD') :'';
                      newArr.push(item);
                  }
                  return newArr;
              }, []);

              data.workings = this.workings.items.reduce((newArr, item) => {
                  if (((item.employer || '') != '') && ((item.title || '') != '') && (item.startDate)) {
                      item.startDate = (item.startDate) ? moment(item.startDate).format('YYYY-MM-DD') :'';
                      item.endDate = (item.endDate) ? moment(item.endDate).format('YYYY-MM-DD') :'';
                      newArr.push(item);
                  }
                  return newArr;
              }, []);

              data.familyMembers = this.familyMembers.items.reduce((newArr, item) => {
                  if ((item.DOB || '') != '') {
                      item.DOB = (item.DOB) ? moment(item.DOB).format('YYYY-MM-DD') :null;
                      newArr.push(item);
                  }
                  return newArr;
              }, []);

              await crew.save(data);
              this.close();
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message, "Error Info",10000);
                } else {
                    toastr.error(JSON.stringify(error), "Error Info",10000);
                }              
            }
        }
    },
    close(){
        router.push({name: 'hrm.employee'});
    },    
          toggleShowImg() {
                this.showImgTool = !this.showImgTool;
            },
            /**
             * crop success
             *
             * [param] imgDataUrl
             * [param] field
             */
            cropSuccess(imgDataUrl, field){
                console.log('-------- crop success --------', field);
                this.imgDataUrl=imgDataUrl;
                // console.log(imgDataUrl);
                // console.log('content ',this[field]);
            },
            /**
             * upload success
             *
             * [param] jsonData  server api return data, already json encode
             * [param] field
             */
            cropUploadSuccess(jsonData, field){
                console.log('-------- upload success --------');
                // console.log(jsonData);
                console.log('field: ' + field);
            },
            /**
             * upload fail
             *
             * [param] status    server api return error status, like 500
             * [param] field
             */
            cropUploadFail(status, field){
                console.log('-------- upload fail --------');
                // console.log(status);
                // console.log('field: ' + field);
            }


  }
}
</script>